import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import Home from './pages/Home';
import Hizmetler from './pages/Hizmetler';
import Hakkimizda from './pages/Hakkimizda';
import Iletisim from './pages/Iletisim';
import Randevu from './pages/Randevu';

const App: React.FC = () => {
  return (
    <Router>
      <div className="flex flex-col min-h-screen">
        <Header />
        <main className="flex-grow">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/hizmetler" element={<Hizmetler />} />
            <Route path="/hakkimizda" element={<Hakkimizda />} />
            <Route path="/iletisim" element={<Iletisim />} />
            <Route path="/randevu" element={<Randevu />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
  );
};

export default App; 